import { ChangeEvent, ReactElement, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab, Tabs
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {
  IAcquisitionVariable,
  IAnnotation,
  IDashboardAcquisitionVariable, ILimit
} from "../types";
import { cloneObject } from "../../../system/utils";
import TabPanel from "../../../components/tabPanel";
import { useSelector } from "react-redux";
import { IState } from "../../../types";
import AnnotationsPanel from "./annotationsPanel";
import LimitsPanel from "./limitsPanel";
import AxisPanel from "./axisPanel";
import { IAxisLinear } from "../../../components/charts/types";


interface IProps {
  variable: IDashboardAcquisitionVariable | null;
  metaData: IAcquisitionVariable | null;
  open: boolean;
  setOpen: (open: boolean) => void;
  machineVariables: IAcquisitionVariable[];
}

const VariablesConfigDialog = ({ variable, open, setOpen, metaData, machineVariables }: IProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [ selectedTab, setSelectedTab ] = useState(0);
  const [ annotations, setAnnotations ] = useState<IAnnotation[]>([]);
  const [ limits, setLimits ] = useState<ILimit[]>([]);
  const [ axis, setAxis ] = useState<IAxisLinear>({ name: "Y", minimum: 0, maximum:  100, ticksCount: 3 });

  useEffect(() => {
    if (variable) {
      setAxis(cloneObject(variable.yAxis));
      setAnnotations(cloneObject(variable.annotations));
      setLimits(cloneObject(variable.limits));
    }
  }, [ variable ]);

  const onAccept = () => {
    if (variable) {
      variable.yAxis = axis;
      variable.annotations = annotations;
      variable.limits = limits;
    }

    setOpen(false);
  };

  const onCancel = () => {
    setOpen(false);
  };


  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Dialog onClose={onCancel} aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
      <DialogTitle id="customized-dialog-title">
        Variable Config
      </DialogTitle>
      <DialogContent dividers={true} >
        <div style={{ height: 320, width: 670 }}>
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered={true}
            style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
            <Tab label="Axis"/>
            <Tab label="Annotations"/>
            <Tab label="Limits"/>
          </Tabs>

          <TabPanel value={selectedTab} index={0}>
            <AxisPanel axis={axis} setAxis={setAxis} metaData={metaData} />
          </TabPanel>

          <TabPanel value={selectedTab} index={1}>
            <AnnotationsPanel annotations={annotations} setAnnotations={setAnnotations} />
          </TabPanel>

          <TabPanel value={selectedTab} index={2}>
            <LimitsPanel limits={limits} setLimits={setLimits} machineVariables={machineVariables} />
          </TabPanel>

        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onAccept} variant="contained" color="primary" startIcon={<CheckIcon />}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VariablesConfigDialog;
